// generalStore.js

import { writable } from 'svelte/store';
import { prizes } from './prizes';
import { untilLiveDraw, untilThursdayDraw, daysRemaining } from '$lib/helpers';
import { getPrizeCount } from '$lib/firestore/getPrizeCount';

const internalGeneralStore = writable({
  daysUntilMonday: null,
  daysUntilThursday: null,
  prizeCount: 0,
  filters: []
});

async function fetchGeneralData() {
  // Collect category values from $prizes instead of productStore
  let categories = [];
  const unsubscribe = prizes.subscribe(($prizes) => {
    categories = $prizes.map((item) => item.category);
  });
  unsubscribe();

  const uniq = Array.from(new Set(categories));
  const monday = untilLiveDraw();
  const thursday = untilThursdayDraw();

  const [daysUntilMonday, daysUntilThursday, prizeCount] = await Promise.all([
    daysRemaining(monday),
    daysRemaining(thursday),
    getPrizeCount()
  ]);

  internalGeneralStore.set({
    filters: uniq,
    daysUntilMonday,
    daysUntilThursday,
    prizeCount
  });
}

// Fire once at startup
fetchGeneralData();
// Re‐fetch whenever the `prizes` store changes
prizes.subscribe(() => {
  fetchGeneralData();
});

export const generalStore = {
  subscribe: internalGeneralStore.subscribe
};
